import { Context } from "@nuxt/types";

import { type ManyProductDetailsResponse } from "@/store/product-details/types";
import Api from "@/utils/api";
import debounce from "@/utils/debounce";

interface GetParams {
  ids: string[];
}

export default class ProductsApi extends Api {
  readonly url = "/v2/product_details/";

  constructor($axios: Context["$axios"]) {
    super("consumerProductService", $axios);
  }

  async get({ ids }: GetParams) {
    return await this.request<ManyProductDetailsResponse>({
      method: "GET",
      params: {
        ids,
      },
    });
  }

  @debounce({ timeout: 50, aggregate: true, batch: 50 })
  async getOne(...ids: string[]) {
    return await this.get({ ids });
  }
}
